import React from 'react';
import { SHOW_LESSON_TRANSLATIONS } from 'app/models/localStorage/constants';
import LessonTranslationToggle from 'app/components/publishedLesson/LessonTranslationToggle';
import { createStorageHook, booleanParser } from 'app/components/storage/createStorageHook';
import { StorageType } from 'app/utils/StorageContext';
import { useIsPublishedLessonPage } from 'app/containers/publishedLesson/PublishedLessonLoadingStatePage';

const useShowLessonTranslationsSetting = createStorageHook(
  SHOW_LESSON_TRANSLATIONS,
  booleanParser,
  StorageType.LOCAL,
);

export const useShowLessonTranslations = () => {
  const isPublishedLessonPage = useIsPublishedLessonPage();
  const [showLessonTranslations] = useShowLessonTranslationsSetting();

  // Only allow hiding of translations on published lesson pages.
  return isPublishedLessonPage ? showLessonTranslations : true;
};

const PersistedLessonTranslationToggle = () => {
  const [showTranslations, setShowTranslations] = useShowLessonTranslationsSetting();

  const toggleTranslations = () => {
    setShowTranslations(!showTranslations);
  };

  return (
    <LessonTranslationToggle
      showTranslations={showTranslations}
      toggleTranslations={toggleTranslations}
    />
  );
};

export default PersistedLessonTranslationToggle;
